export const PROCESSING_STEPS = [
  {
    step_id: 1,
    name: 'Data Ingestion',
    is_complete: false,
    is_active: true,
    step_description: 'Loading and combining data from base templates.',
  },
  {
    step_id: 2,
    name: 'Data Cleansing',
    is_complete: false,
    is_active: false,
    step_description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, beatae?',
  },
  {
    step_id: 3,
    name: 'Data Enrichment',
    is_complete: false,
    is_active: false,
    step_description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, beatae?',
  },
  {
    step_id: 4,
    name: 'Data Aggregation',
    is_complete: false,
    is_active: false,
    step_description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, beatae?',
  },
  {
    step_id: 5,
    name: 'Processing Table Level Checks',
    is_complete: false,
    is_active: false,
    step_description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, beatae?',
  },
];

export const PROCESSED_FILES_STATUS = [
  {
    group: 'Masters',
    processed_status_percent: 100,
    files: [
      {
        name: 'Location',
        processed: true,
      },
      {
        name: 'Plant Information',
        processed: true,
      },
      {
        name: 'Mapping',
        processed: true,
      },
    ],
  },
  {
    group: 'Demand & Inventory',
    processed_status_percent: 60,
    files: [
      {
        name: 'Demand1',
        processed: true,
      },
      {
        name: 'Inventory1',
        processed: false,
      },
      {
        name: 'Demand_US',
        processed: false,
      },
    ],
  },
  {
    group: 'Finance',
    processed_status_percent: 30,
    files: [
      {
        name: 'Finance1',
        processed: true,
      },
      {
        name: 'US_Finance',
        processed: true,
      },
      {
        name: 'US_Finance2',
        processed: false,
      },
      {
        name: 'Finance_Canada',
        processed: false,
      },
      {
        name: 'Finance_Canada2',
        processed: false,
      },
    ],
  },
  {
    group: 'Operations & manufacturing',
    processed_status_percent: 90,
    files: [
      {
        name: 'Operations',
        processed: true,
      },
      {
        name: 'US_Operations',
        processed: false,
      },
      {
        name: 'US_Mfg',
        processed: false,
      },
      {
        name: 'Manufacturing_Canada',
        processed: false,
      },
      {
        name: 'Operations_Canada2',
        processed: false,
      },
    ],
  },
  {
    group: 'Logistics',
    processed_status_percent: 67,
    files: [
      {
        name: 'US_Logistics',
        processed: true,
      },

      {
        name: 'Logistics_Canada',
        processed: false,
      },
      {
        name: 'Logistics_Canada2',
        processed: false,
      },
    ],
  },
];

export const ERROR_TYPES = [
  {
    id: 1,
    header: 'Blank Values',
    type: 'warning',
    description: 'Validates that all mandatory fields have been populated.',
    cells_affected: 54,
  },
  {
    id: 2,
    header: 'Completeness Check',
    type: 'warning',
    description: 'Validates if all data is present across all time frames etc.; field or record completeness.',
    cells_affected: 20,
  },
  {
    id: 3,
    header: 'Data Redundancy',
    type: 'error',
    description: 'Identify and highlight duplicate records or rows that have identical data.',
    cells_affected: 14,
  },
  {
    id: 4,
    header: 'Data Type Validation',
    type: 'error',
    description: 'Ensures all data in a column is in the specified data type.',
    cells_affected: 9,
  },
];

export const MONTH_ARRAY = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const GROUP_MAP_OBJECT: { [key: string]: string } = {
  All: 'all',
  'Pack Attribute': 'pack_format',
  'Process Attribute': 'product_format',
  'Product Attribute': 'product_format',
  Line: 'line_code',
  Plant: 'plant_code',
  'Mfg Ntw': 'manufacturing_network',
  'Mfg. Network': 'manufacturing_network',
  'Manufacturing Network': 'manufacturing_network',
  'Time Period (Annual)': 'year',
  'Time Period (Quarters)': 'quarter',

  Demand: 'demand',
  Inventory: 'closing_inventory',

  Production: 'total_feasible_production',
  'Production Requirement': 'prod_req',
  'Total Production Requirement': 'prod_req',
  'Internal Production Requirement': 'internal_production_req',
  'External Production Requirement': 'external_production_req',
  'Total Production': 'total_feasible_production',
  'Internal Production': 'internal_production',
  'External Production': 'external_production',

  'Capacity (Baseline)': 'base_capacity',
  'Gap Capacity (Baseline)': 'gap_capacity',
  'New Capacity': 'total_capacity',
  'Total Capacity': 'total_capacity',
  'Internal Capacity': 'internal_capacity',
  'External Capacity': 'external_capacity',
  'New Gap Capacity': 'total_gap_capacity',
  'Gap Capacity': 'total_gap_capacity',
  'Spare Capacity': 'total_spare_capacity',

  'C:D': 'total_c_to_d',
  'C:D (Baseline)': 'c_to_d',
  'New C:D': 'total_c_to_d',

  'GE %': 'ge',
  'Waste %': 'wastage',
  'Shifts Allocated': 'shifts',
  CAPEX: 'total_capex',
};

export const COMMON_CATEGORIES = [
  'Demand',
  'Production Requirement',
  'Capacity (Baseline)',
  'Gap Capacity (Baseline)',
  'C:D (Baseline)',
  'New Capacity',
  'New Gap Capacity',
  'New C:D',
  'CAPEX',
  '',
];

export const SIMULATION_SPECIFIC_CATEGORIES = ['Production', 'Inventory'];

export const KPI_DASHBOARD_SPECIFIC_CATEGORIES = [
  'Total Production Requirement',
  'Internal Production Requirement',
  'External Production Requirement',
  'Total Capacity',
  'Internal Capacity',
  'External Capacity',
  'Total Production',
  'Internal Production',
  'External Production',
  'Inventory',
  'Gap Capacity',
  'Spare Capacity',
  'C:D',
  'GE %',
  'Waste %',
  'Shifts Allocated',
];

export const MUPS_SPECIFIC_CATEGORIES = [
  'Demand (MUPs + Non MUPs)',
  'Processing Capacity (MUPs + Non MUPs)',
  'Processing C:D (MUPs + Non MUPs)',
  'Processing Gap Capacity (MUPs + Non MUPs)',
  'Demand (MUPs)',
  'Packaging Capacity (MUPs)',
  'Packaging C:D (MUPs)',
  'Packaging Gap Capacity (MUPs)',
];

// Construct the final category lists
export const AVAILABLE_CATEGORIES_MDM = [...COMMON_CATEGORIES];
export const AVAILABLE_CATEGORIES_SIMULATION = [...COMMON_CATEGORIES, ...SIMULATION_SPECIFIC_CATEGORIES];
export const AVAILABLE_CATEGORIES_KPI_DASHBOARD = [...COMMON_CATEGORIES, ...KPI_DASHBOARD_SPECIFIC_CATEGORIES];
export const AVAILABLE_CATEGORIES_MUPS = [...MUPS_SPECIFIC_CATEGORIES, ''];

export const REQUIRED_SIMULATION_PAYLOAD_KEYS = [
  'supply_mode',
  'scenario_id',
  'iteration_code',
  'row_group',
  'column_group',
  'data_category',
  'firm_type',
  'category',
  'brand',
  'manufacturing_network',
  'start_year',
  'end_year',
  'node_type',
  'plant_code',
  'node_code',
  'geography',
  'sort_by',
];

export const LEGEND_ARRAY = [
  { text: `C:D <= 1.1`, bgColor: '#ECC3BD' },
  { text: `1.1 < C:D < 1.15`, bgColor: '#FDEBCB' },
  { text: `C:D >= 1.15`, bgColor: '#C4D4BD' },
];
